import {FormikValues} from 'formik'
import moment from 'moment'
import {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import {
  BooleanApiData,
  IyzicoOptionMaskedDto,
  IyzicoOptionMaskedDtoApiData,
  IyzicoOptionUpsertRequest,
} from '../../../api/data-contracts'
import {
  Api_Payment_CreateIyzicoOption,
  Api_Payment_DeleteIyzicoOption,
  Api_Payment_GetIyzicoOption,
  Api_Payment_UpdateIyzicoOption,
} from '../../../apiClient/apiClient'
import FormMessage from '../../../components/common/messages/FormMessage'
import FormikForm from '../../../components/form/FormikForm'
import FormInput from '../../../components/form/FormInput'
import {getRequestAsync, postRequestAsync} from '../../../redux/commonSlice'
import {FormStatus} from '../../../types/FormStatus'

function IyzicoOptionSection() {
  const dispatch = useDispatch()
  const [existing, setExisting] = useState<IyzicoOptionMaskedDto | null>(null)
  const [loaded, setLoaded] = useState(false)

  const fetchExisting = async () => {
    await dispatch<any>(
      getRequestAsync({
        getRequestFunction: Api_Payment_GetIyzicoOption,
      })
    )
      .unwrap()
      .then(async (response: IyzicoOptionMaskedDtoApiData) => {
        setExisting(response.data ?? null)
        setLoaded(true)
      })
  }

  useEffect(() => {
    fetchExisting()
  }, [])

  const submit = async (values: IyzicoOptionUpsertRequest, actions: FormikValues) => {
    actions.setStatus()
    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: existing
          ? Api_Payment_UpdateIyzicoOption
          : Api_Payment_CreateIyzicoOption,
        body: values,
      })
    )
      .unwrap()
      .then(async (response: IyzicoOptionMaskedDtoApiData) => {
        if (response.isSuccessful) {
          setExisting(response.data ?? null)
          actions.setStatus(new FormStatus(true, 'Iyzico ayarları kaydedildi.'))
          actions.resetForm({values: {apiKey: '', secretKey: ''}})
        } else {
          actions.setStatus(new FormStatus(false, response.serverMessage))
        }
      })
  }

  const handleDelete = async () => {
    if (!window.confirm('Iyzico ayarları silinsin mi?')) return
    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Payment_DeleteIyzicoOption,
        body: {},
      })
    )
      .unwrap()
      .then(async (response: BooleanApiData) => {
        if (response.data === true) {
          setExisting(null)
        }
      })
  }

  const initData: IyzicoOptionUpsertRequest = {
    apiKey: '',
    secretKey: '',
  }

  const schema = Yup.object({
    apiKey: Yup.string().required('Zorunlu alan'),
    secretKey: Yup.string().required('Zorunlu alan'),
  })

  if (!loaded) return null

  return (
    <>
      {existing && (
        <div className='card card-dashed p-6 mb-5'>
          <div className='row mb-2'>
            <div className='col-xl-3 fw-bold'>API Key</div>
            <div className='col-xl-9'>{existing.apiKey}</div>
          </div>
          <div className='row mb-2'>
            <div className='col-xl-3 fw-bold'>Secret Key</div>
            <div className='col-xl-9'>{existing.secretKey}</div>
          </div>
          <div className='row mb-3'>
            <div className='col-xl-3 fw-bold'>Oluşturulma</div>
            <div className='col-xl-9'>
              {existing.createdAt && moment(existing.createdAt).format('DD.MM.yyyy HH:mm')}
            </div>
          </div>
          <div className='row'>
            <div className='col-xl-12 text-end'>
              <button type='button' className='btn btn-danger btn-sm' onClick={handleDelete}>
                Sil
              </button>
            </div>
          </div>
        </div>
      )}

      <FormikForm
        initialValues={initData}
        onSubmit={submit}
        validationSchema={schema}
        enableReinitialize={true}
      >
        {(form_props) => (
          <>
            <div className='row'>
              <div className='col-xl-6 mb-5'>
                <FormInput
                  fieldAttributes={{
                    type: 'text',
                    name: 'apiKey',
                    placeholder: 'API Key',
                  }}
                  istouched={form_props.touched.apiKey ?? false}
                  errorMessage={form_props.errors.apiKey}
                  placeHolderOnTop={true}
                  isRequired={true}
                  checkValid={true}
                />
              </div>
              <div className='col-xl-6 mb-5'>
                <FormInput
                  fieldAttributes={{
                    type: 'text',
                    name: 'secretKey',
                    placeholder: 'Secret Key',
                  }}
                  istouched={form_props.touched.secretKey ?? false}
                  errorMessage={form_props.errors.secretKey}
                  placeHolderOnTop={true}
                  isRequired={true}
                  checkValid={true}
                />
              </div>
            </div>
            <div className='row mb-5'>
              <div className='col-xl-12 text-end'>
                <button type='submit' className='btn btn-primary'>
                  {existing ? 'Güncelle' : 'Kaydet'}
                </button>
              </div>
            </div>
            <div className='row'>
              <div className='col-xl-12'>
                <FormMessage {...form_props.status} />
              </div>
            </div>
          </>
        )}
      </FormikForm>
    </>
  )
}

export default IyzicoOptionSection
